import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'upperSnakeCase' })
@Injectable({ providedIn: 'root' })
export class UpperSnakeCasePipe implements PipeTransform {
  transform(value: string): string {
    return value
      .replace(/-/g, '_')
      .replace(/([A-Z])/g, '_$1')
      .replace(/^_/, '')
      .toUpperCase();
  }
}
